import classNames from 'classnames';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { useEffect, useRef, useState } from 'react';
import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import { useI18n } from 'next-localization';
import { getCookie, setCookie } from 'hooks/useCookie';
import ScRichText from 'components/Generic/SitecoreWrappers/RichText';
import styles from './DisclaimerModalContent.module.scss';

const date = new Date();
const NINETY_DAYS_IN_MS = date.setTime(date.getTime() + 90 * 24 * 60 * 60 * 1000);

const DisclaimerModalContent = ({ fields, context, closeModal }) => {
  const { t } = useI18n();
  const content = useRef();
  const [isContentOverflow, setIsContentOverflow] = useState(false);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

  const scrollListener = (e): void => {
    const elem = e.currentTarget;
    setIsScrolledToBottom(elem.scrollHeight - (elem.scrollTop + elem.clientHeight) < 5);
  };

  const acceptHandler = () => {
    const oldCookie = JSON.parse(getCookie('abrdn-disclaimer') || null);
    /*
     * n - sitename
     * e - endDate
     * s - sessionId
     * l - language code
     * */
    const value = {
      n: context.site.name,
      e: undefined,
      s: undefined,
      l: context.language,
    };
    //const isSessionBased = this.fields.session.value;
    const isSessionBased = false;
    if (isSessionBased) {
      value.s = getCookie('ASP.NET_SessionId');
    } else {
      value.e = NINETY_DAYS_IN_MS;
    }
    const cookieValue = oldCookie || [];
    const expiredCookieIndex = cookieValue.findIndex(
      (cookie) => cookie.n === context.site.name && cookie.l === context.language
    );
    if (expiredCookieIndex !== -1) {
      cookieValue.splice(expiredCookieIndex, 1);
    }
    cookieValue.push(value);
    setCookie('abrdn-disclaimer', JSON.stringify(cookieValue), 9999);

    content.current.removeEventListener('scroll', scrollListener);
    closeModal();
  };

  useEffect(() => {
    if (content.current) {
      const contentOverflowValue = content.current.scrollHeight > content.current.clientHeight;
      setIsContentOverflow(contentOverflowValue);
      if (contentOverflowValue) {
        content.current.addEventListener('scroll', scrollListener, { passive: true });
      }
    }
  }, []);

  return (
    <div
      className={classNames({
        [styles['disclaimer-modal']]: true,
        [styles['disclaimer-modal--overflow']]: isContentOverflow,
        [styles['disclaimer-modal--reach-end']]: isScrolledToBottom,
      })}
    >
      <div className={`${styles['disclaimer-modal__wrapper']} background-white`}>
        <div className={`${styles['disclaimer-modal__heading']} px-2 px-md-3 py-3`}>
          <Text tag="h5" field={fields.title} className="subheader-1" />
        </div>
        <div
          ref={content}
          className={classNames('mx-2 mx-md-3 py-3', {
            [styles['disclaimer-modal__content']]: true,
            'pe-3': isContentOverflow,
          })}
          tabIndex={isContentOverflow ? '0' : '-1'}
        >
          <ScRichText spacingType="tight" fields={fields} />
        </div>
        <div className={`${styles['disclaimer-modal__bottom']} p-3`}>
          <AbrdnButton linkField={fields.declineLink} buttonType="secondary">
            <span>{t('decline')}</span>
          </AbrdnButton>
          <AbrdnButton buttonType="primary" onClick={acceptHandler}>
            <span>{t('accept')}</span>
          </AbrdnButton>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerModalContent;
